// extracted by mini-css-extract-plugin
module.exports = {"keyFeaturesContainer":"_eede96"};